// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-volume-controller{padding:10px}.w-volume-controller__menu .v-menu__content{box-shadow:none}.w-volume-controller .v-input--slider{margin-top:0}.w-volume-controller .v-input__control .v-messages{display:none}.w-volume-controller .v-input__slot{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
